export const getPathnameFromPath = (pathOrUrl: string): string => {
    try {
        return new URL(pathOrUrl, 'https://x').pathname;
    } catch {
        return pathOrUrl.split('?')[0].split('#')[0];
    }
};

const restrictedAccountUrls = /^\/account\/(?!order-details\/\d+\?email=[^&]+)(?!order-search\/?$)(?!contact\/?$).*/;
const restrictedTreatsRewardsUrls = /^.*\/treats-rewards\/authenticated(?:\/.*)?$/;
const restrictedCheckoutUrl = /^.*\/checkout\/?$/;

export const isRestrictedPathname = (currentPathname: string): boolean => {
    const pathnameOnly = getPathnameFromPath(currentPathname);
    return (
        restrictedAccountUrls.test(pathnameOnly) ||
        restrictedTreatsRewardsUrls.test(pathnameOnly) ||
        restrictedCheckoutUrl.test(pathnameOnly)
    );
};
